export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "一般",
    },
    {
      value: 1,
      name: "Collection",
      text: "代收",
    },
    {
      value: 2,
      name: "Payment",
      text: "代支",
    },
    {
      value: 3,
      name: "Sale",
      text: "單據",
    },
    {
      value: 4,
      name: "Food",
      text: "商品",
    },
    {
      value: 5,
      name: "DeleteFood",
      text: "刪項",
    },
    {
      value: 7,
      name: "VoidSale",
      text: "作廢",
    },
    {
      value: 8,
      name: "VoidDeposit",
      text: "作廢儲值單",
    },
    {
      value: 9,
      name: "RejectOnlineOrder",
      text: "拒接網路訂單",
    },
    {
      value: 10,
      name: "StockAdjust",
      text: "調整單",
    },
    {
      value: 12,
      name: "MemberLabel",
      text: "會員群組",
    },
    {
      value: 13,
      name: "FoodLabel",
      text: "商品標記",
    },
    {
      value: 14,
      name: "StopSale",
      text: "暫時停售",
    },
  ];
}

export function getWithIndustryRetail() {
  var types = getAll();
  types.splice(5, 1);
  return types;
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}
